import React from 'react';
import { useNavigate } from 'react-router-dom';
import CategoryBadge from './CategoryBadge';
import ReactionButtons from './ReactionButtons';
import { formatDate } from '../utils/dateFormatter';
import './PostCard.css';

const PostCard = ({ post, onUpdate }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/feed/${post.id}`);
  };

  const handleReactionUpdate = (updatedReactions) => {
    if (onUpdate) {
      onUpdate({ ...post, ...updatedReactions });
    }
  };

  return (
    <div className="post-card">
      <div className="post-card-header">
        <div className="post-author">
          <img 
            src={post.user.avatarUrl || '/img/user-man.png'} 
            alt={post.user.username}
            className="author-avatar"
          />
          <div className="author-info">
            <span className="author-name">{post.user.fullName || post.user.username}</span>
            <span className="post-time">{formatDate(post.createdAt)}</span>
          </div>
        </div>
        <CategoryBadge category={post.category} />
      </div>

      <div className="post-card-body" onClick={handleClick}>
        <h3 className="post-title">{post.title}</h3>
        <p className="post-content">
          {post.content.length > 200 
            ? `${post.content.substring(0, 200)}...` 
            : post.content}
        </p>
      </div>

      <div className="post-card-footer">
        <ReactionButtons
          postId={post.id}
          initialLikes={post.likesCount}
          initialDislikes={post.dislikesCount}
          initialUserReaction={post.userReaction}
          onUpdate={handleReactionUpdate}
        />
        <button className="comment-count-btn" onClick={handleClick}>
          <span className="comment-icon">💬</span>
          <span>{post.commentsCount} {post.commentsCount === 1 ? 'comment' : 'comments'}</span>
        </button>
      </div>
    </div>
  );
};

export default PostCard;
